<template>
  <transition name="appfade">
    <div v-show="appIsLoaded" class="generic-page--template page-template">
      <div class="db relative center z-0 w-100 h-auto">
        <div class="container-fluid">
          <section class="db relative center mw8 tc pt5 pt6-ns pb5">
              <h3 class="tc mv4 ttu is-bebas is-white page-title">{{ page.title }}</h3>
              <div class="row middle-sm mv3 mv4-ns">
                <div class="col-xs-12 col-sm-4" v-for="gallery in page.Galleries">
                  <a class="flex relative center flex-row items-center w-100 mv3 mv2-ns aspect-ratio--1x1 bg-center pointer br2 gallery-tile grow js-image-gallery" :style="{ 'background-image': 'url(' + gallery.cover_image + ')' }" @click="openGallery(gallery.images)">
                    <span class="db absolute center w-100 left-0 right-0 abs-vert-center tc ttu f2 is-bebas text">
                      {{ gallery.name }}
                    </span>
                  </a>
                </div>
              </div>
              <!-- <p>{{ page.Galleries[0].images }}</p> <div class="cms-content tl is-interstate-regular is-white" v-html="page.content"></div> -->
          </section>
        </div>
      </div>
    </div>
  </transition> 
</template>

<script>
//import { bus } from '../assets/js/src/main';
import PhotoSwipe from '../node_modules/photoswipe/dist/photoswipe.min';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import Marked from 'marked';
export default {
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk} | ` + this.$site_name : this.$site_name;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      appIsLoaded: true,
      newItem: 'Data binding',
      newDynamic: [],
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName(this.pageMarkdownFileName);
      return pageData[0];
    }
  },
  methods : {
    openGallery(data) {
      //console.log('openGallery - ', data);

      var siteUrl = window.location.origin;

      var pswpElement = document.querySelectorAll('.pswp')[0];
      var options = {
        index: 0,
        history: false,
        focus: false,
        closeOnScroll: false,
        showAnimationDuration: 0,
        showHideOpacity: true,
        hideAnimationDuration: 0 ,
        shareButtons: [
            {id:'facebook', label:'Share on Facebook', url:'https://www.facebook.com/dialog/feed?app_id=133331760830504&link={{url}}&picture='+siteUrl+'/{{image_url}}'},
            {id:'twitter', label:'Tweet', url:'https://twitter.com/intent/tweet?text={{url}}'},
            {id:'pinterest', label:'Pin it', url:'http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}'},
            {id:'download', label:'Download image', url:'{{raw_image_url}}', download:true}
        ]
      };

      //console.log('openGallery 2 -  ', data);

      var imageListArray = [];

      //console.log('openGallery 2.1 -  ', imageListArray);

      Object.keys(data).forEach(key => {
          let val = data[key] // value of the current key
          //console.log('val 1 - ', val , val.image)
          imageListArray.push({
              src: val.image,
              title: '<h2 class=\"tc\">' + val.caption + '</h2><p class=\"tc\">Photo Credit: ' + val.credit + '</p>', 
              w: 0, 
              h: 0
          });
      })

      //console.log('3 - imageListArray: ', imageListArray)

      var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, imageListArray, options);
      gallery.listen('gettingData', function(index, item) {
        if (item.w < 1 || item.h < 1) { // unknown size
          var img = new Image();
          img.onload = function() { // will get size after load
          item.w = this.width; // set image width
          item.h = this.height; // set image height
            gallery.invalidateCurrItems(); // reinit Items
            gallery.updateSize(true); // reinit Items
          }
          img.src = item.src; // let's download image
        }
      });
      gallery.init();
    }
  },
  mounted() {

    this.$nextTick(() => {
      /****************************
        DOC READY
      ****************************/
      /*
        $(function() {

        })
      */
    })
        
  }
}
</script>